import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <span className="font-heading font-extrabold text-7xl md:text-9xl text-primary-100 select-none">
          404
        </span>
        <h1 className="mt-4 font-heading font-semibold text-xl md:text-2xl text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-500 max-w-md">
          你访问的页面不存在或已被移动：
          <span className="block mt-1 font-mono text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-2 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-medium flex items-center gap-2 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line"></i>
            去搜索作品
          </Link>
        </div>
      </div>
    </Layout>
  );
}